import React from 'react'
import { Card, Row, Col, Skeleton } from 'antd'

const SkeletonReportSection = () => {
    return (
        <div style={{ width: '100%' }}>
            <Card bordered style={{ height: '100%' }}>
                <Row gutter={[16, 16]} style={{ width: '100%' }} align="middle">
                    {/* Left: Chart placeholder */}
                    <Col xs={24} md={11}>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: 250,
                            }}
                        >
                            <Skeleton.Avatar
                                active
                                shape="circle"
                                size={200} // circle simulates pie chart
                            />
                        </div>
                    </Col>

                    {/* Right: Stats placeholder */}
                    <Col xs={24} md={12}>
                        <Skeleton
                            active
                            paragraph={{ rows: 4 }} // multiple lines
                            title={{ width: '60%' }}
                        />
                    </Col>
                </Row>
            </Card>
        </div>
    )
}

export default SkeletonReportSection
